import Vue from 'vue';
import Vuex from 'vuex';
// import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';
import dataSet from './../data/data.json';

const state = {
  dataSet: dataSet.sort((a, b) => a.rank.m17 - b.rank.m17),
  lng: 'ua',
  content: {
    ua: {
      title: 'ІНДЕКС СПРИЙНЯТТЯ КОРУПЦІЇ-2018',
      subTitle: 'На сьогоднішній день індекс сприйняття корупції України складає 32 балів з 100 можливих, що на 1 бал більше, ніж минулого року.',

      // Текстовый блок номер 1
      textBlock1Text: 'Індекс сприйняття корупції - глобальний рейтинг оцінки стану корупції в країнах світу, який з 1995 року укладає організація Transparency International. В основі - дослідження авторитетних установ та міжнародних організацій, що базуються на опитуваннях аналітиків та експертів.',


      header1: 'СВІТОВИЙ РЕЙТИНГ',
      subHeader1: 'послідовність згідно рейтингу 2018 року',
      btn1: 'Всі країни',
      btn2: 'Пн та Пд Америка',
      btn3: 'Азія та Океанія',
      btn4: 'Близький Схід та Пн Африка',
      btn5: 'Африка',
      btn6: 'Європейський союз та Зх Європа',
      btn7: 'Сх Європа та Цн Азія',
      btn8: 'Організація економічного співробітництва та розвитку',
      btn9: 'Країни “Великої двадцятки”',
      btn10: 'Бразилія, Росія, Індія, Китай, Південна Африка',
      btn11: 'Арабські країни',
      header2: 'Порівняння показників країн між собою',
      header3: 'ГЕОГРАФІЯ ІНДЕКСУ СПРИЙНЯТТЯ КОРУПЦІЇ-2018',
      subHeader3: 'послідовність згідно рейтингу 2018 року',
      header4: 'ІНДЕКС СПРИЙНЯТТЯ КОРУПЦІЇ-2018 ТА ДОСЛІДЖЕННЯ НА ОСНОВІ ЯКИХ ВІН РОЗРАХОВАНИЙ',
      subHeader4: 'послідовність згідно рейтингу 2018 року',
      rank: 'Місце у рейтингу',
      cpi: 'Кількість балів',
      bals: 'балів зі',

      // Первая секция с видео
      videoHeader: 'ДИНАМІКА ЗМІНИ ІНДЕКСА СПРИЙНЯТТЯ КОРУПЦІЇ В УКРАЇНІ ',

      mapLegend: 'Кількість балів згідно з Індексом сприйняття корупції-2018. 0 - корупція підміняє собою державу, 100 - корупція майже відсутня.',

      infoHeader: 'Динаміка зміни Індексу 2017-2018',
    },
    en: {
      title: 'Corruption Perception Index 2018',
      subTitle: 'Currently, Ukraine`s corruption perception index score is 32 points out of 100 possible, 1 point up from last year`s result.',

      // Текстовый блок номер 1
      textBlock1Text: 'Corruption Perception Index is a global rating of the situation with corruption across the world, first launched by Transparency International in 1995. It is informed by research carried out by reputable institutions and international organizations based on surveys of analysts and experts.',


      header1: 'WORLD RANKING',
      subHeader1: 'organized by rank in CPI 2018 left to right',
      btn1: 'All countries',
      btn2: 'North and South America',
      btn3: 'Asia and Oceania',
      btn4: 'Middle East and North Africa',
      btn5: 'Africa',
      btn6: 'European Union and Western Europe',
      btn7: 'Сх Європа та Цн Азія',
      btn8: 'Organization of economic cooperation and development',
      btn9: 'The G-20 Countries',
      btn10: 'Brazil, Russia, India, China, South Africa',
      btn11: 'Arab countries',
      header2: 'Compare scores of any two countries according to CPI 2017',
      header3: 'Geographical distribution',
      subHeader3: 'Ranking based on CPI 2018',
      header4: 'Table with Benchmark Data',
      subHeader4: 'ranked by CPI 2018 position',
      rank: 'CPI 2018 position',
      cpi: 'Points out of 100',
      bals: 'points out of',

      // Первая секция с видео
      videoHeader: 'Ukraine’s History in CPI',

      mapLegend: 'The Index uses a scale from 0 (“highly corrupt”) to 100 (“very clean”).',

      infoHeader: 'CPI 2017-2018: dynamics of change',
    },
  },
};

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';


export default new Vuex.Store({
  state,
  mutations,
  // actions,
  getters,
  strict: debug,
  // plugins: debug ? [createLogger()] : []
});



// WEBPACK FOOTER //
// ./src/store/index.js